import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function AlertDialog({ open, close, data }) {

  return (
    <Dialog open={open} onClose={close} scroll="paper" aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title" color="secondary">{data.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {
            data.listdata.map(item => <span key={item.id}>{item.text} <strong>{item.highlight}</strong><br /><br /></span>)
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">Ok</Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlertDialog;
